const classSizes = [
  {
    Department: 'Data Science',
    Enrolled: 346.4576271186,
  },
  {
    Department: 'Electrical Eng & Computer Sci',
    Enrolled: 111.3600299401,
  },
  {
    Department: 'Mathematics',
    Enrolled: 90.7373319545,
  },
  {
    Department: 'Economics',
    Enrolled: 87.1043723554,
  },
  {
    Department: 'Molecular & Cell Biology',
    Enrolled: 86.4285714286,
  },
  {
    Department: 'Statistics',
    Enrolled: 79.1622807018,
  },
  {
    Department: 'Psychology',
    Enrolled: 73.4052532833,
  },
  {
    Department: 'Nutritional Sciences & Tox',
    Enrolled: 66.1720430108,
  },
  {
    Department: 'IAS Teaching Program',
    Enrolled: 65.9259259259,
  },
  {
    Department: 'Industrial Eng & Ops Research',
    Enrolled: 61.9465240642,
  },
  {
    Department: 'Sociology',
    Enrolled: 61.8337950139,
  },
  {
    Department: 'Haas School of Business',
    Enrolled: 61.4881740776,
  },
  {
    Department: 'Inst of Urban & Reg Dev Pgms',
    Enrolled: 60.0,
  },
  {
    Department: 'Political Science',
    Enrolled: 58.760904685,
  },
  {
    Department: 'Chemistry',
    Enrolled: 55.8862413528,
  },
  {
    Department: 'Neuroscience',
    Enrolled: 53.6666666667,
  },
  {
    Department: 'Gender & Womens Studies',
    Enrolled: 53.0807453416,
  },
  {
    Department: 'Physics',
    Enrolled: 52.8160377358,
  },
  {
    Department: 'Interdisc Social Science Pgms',
    Enrolled: 52.25,
  },
  {
    Department: 'L&S Math & Phys Sciences Div',
    Enrolled: 51.6,
  },
];

export default classSizes;
